var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "#EEFBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 20.1667C39.2316 20.1667 33.7291 25.6692 33.7291 32.4376C33.7291 39.0767 38.9216 44.4501 45.69 44.6826C45.8966 44.6567 46.1033 44.6567 46.2583 44.6826C46.31 44.6826 46.3358 44.6826 46.3875 44.6826C46.4133 44.6826 46.4133 44.6826 46.4391 44.6826C53.0525 44.4501 58.245 39.0767 58.2708 32.4376C58.2708 25.6692 52.7683 20.1667 46 20.1667Z",
    fill: "#5928DC",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1234 51.5542C51.9159 46.7492 40.1617 46.7492 32.9025 51.5542C29.6217 53.75 27.8134 56.7209 27.8134 59.8984C27.8134 63.0759 29.6217 66.0209 32.8767 68.1909C36.4934 70.6192 41.2467 71.8334 46 71.8334C50.7534 71.8334 55.5067 70.6192 59.1234 68.1909C62.3784 65.995 64.1867 63.05 64.1867 59.8467C64.1609 56.6692 62.3784 53.7242 59.1234 51.5542Z",
    fill: "#5928DC",
    fillOpacity: 0.9
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamProfile);
export default __webpack_public_path__ + "static/media/teamProfile.2069595502c9b508589293677643a0ad.svg";
export { ForwardRef as ReactComponent };